import { Injectable } from '@angular/core';
import { NotificationType } from '../../elements/components/notification/entities/notification-types.entity';
import { PartialToast, Toast } from '../entities/toast.entity';

@Injectable()
export class ShToastFactory {
    readonly BASE_DELAY: number = 5000;

    counter = 0;

    public create(toast: PartialToast): Toast {
        const implicitType: NotificationType = toast.type ? toast.type : NotificationType.Default;
        const implicitIcon: string = toast.icon ? toast.icon : this.determineIconByType(implicitType);
        const implicitAutoCloseDelay: number = toast.autoCloseDelay
            ? toast.autoCloseDelay
            : this.determineAutoCloseDelay(implicitType);

        const defaultToast: Toast = {
            id: this.getId(),
            message: '',
            type: implicitType,
            icon: implicitIcon,
            iconRotate: false,
            closable: true,
            autoClose: true,
            autoCloseDelay: implicitAutoCloseDelay
        };

        return { ...defaultToast, ...toast };
    }

    private getId(): number {
        this.counter++;

        return this.counter;
    }

    private determineAutoCloseDelay(type: NotificationType | undefined): number {
        switch (type) {
            case NotificationType.Error:
            case NotificationType.Warning:
                return this.BASE_DELAY * 2;
            case NotificationType.Success:
            case NotificationType.Update:
            default:
                return this.BASE_DELAY;
        }
    }

    private determineIconByType(type: NotificationType | undefined): string {
        switch (type) {
            case NotificationType.Error:
                return 'delete';
            case NotificationType.Warning:
                return 'warning';
            case NotificationType.Success:
                return 'thumbs-up';
            case NotificationType.Update:
                return 'info';
            default:
                return '';
        }
    }
}
